<script setup>
    import { ref, reactive, computed, onUpdated } from 'vue';
    import { useProjectListStore } from '@/lib/stores/project-list-store';

    const items = ref([]);
    const store = useProjectListStore();
    const state = reactive({ activeIndex: store.activePage?.id, itemHeight: 0, itemWidth: 0 });

    const navigate = (page) => {
        store.navigate(page);
    };

    const activeMarkerStyle = computed(() => {
        return {
            height: state.itemHeight + 'px',
            width: state.itemWidth + 3 + 'px',
            left: store.activePage?.id * state.itemWidth + 7 + 10 * store.activePage?.id + 'px'
        };
    });

    const handleResize = () => {
        if (items.value[0] !== undefined) {
            state.itemHeight = items.value[0].clientHeight;
            state.itemWidth = items.value[0].clientWidth;
        }
    };

    onUpdated(() => {
        handleResize();
        window.addEventListener('resize', handleResize);
    });
</script>

<template>
    <div class="flex-container-navigation">
        <nav class="project-list-menu">
            <ul>
                <li class="menu-active" :style="activeMarkerStyle"></li>
                <li v-for="page in store.pages" :key="page.id" ref="items">
                    <button
                        class="btn-page-selector fakta"
                        :class="{ active: page.id == store.activePage?.id }"
                        @click.prevent="navigate(page)"
                    >
                        {{ page.name }}
                    </button>
                </li>
            </ul>
        </nav>
    </div>
</template>
